import { Module } from 'vuex'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'
import state from './state'
import { FacebookState } from './types'
import { RootState } from '../types'

const namespaced: boolean = true

export const facebook: Module<FacebookState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
}
